// Remix Screen
// author rodolfo lopez pintor <rlp@nebular.tv>
//////////////////////////////////////////////////////////////

import m from "mithril";

import {
	defineWidget, CardieWidget, ButtonNew,
	NoticeWidget, Empty,confirm
} from "@nebularstreams/libmui";

import MAINSTATE, {STATE_CHROMAKEY as STATE} from "../State";
import {ContentBrowser} from "./misc/ContentBrowser";
import {TitleBarWidget} from "./misc/TitleBarWidget";
import {ContentItem} from "./remix/VideoBucketList";
import {uploadFile} from "./misc/Uploader";

//////////////////////////////////////////////////////////////

const STR = {
	CLIP_ADDED: "Clip Added to Playlist",
	YOUR_VIDEOS: "Your Backgrounds in nanoStream Storage",
	YOUR_VIDEOS_EMPTY: "No backgrounds in your nanoStream Storage\nTo configure Chroma-Key you first need to upload some backgrounds.\nTry drag-and-drop from your File explorer, or press the button below.",
	YOUR_VIDEOS_EMPTY_FILTER: "No backgrounds matching your search\nPlease refine the search term",

	TITLE: "chromakey - nanoStream Studio",

	NO_ITEM: "No background selected",
	SET_BACKGROUND: "Set As Default Background",
	SET_BACKGROUND_CONFIRM: "Set selected background as default background?",
	DEFAULT_BACKGROUND: "This is the default background: It will be used if no specific watermark is requested when setting up the stream",
};
//////////////////////////////////////////////////////////////

const {service: SERVICE} = STATE;

//////////////////////////////////////////////////////////////
// UI WIDGETS

const

	// widget: the list of videos in the bucket
	VideoContent = defineWidget(
		({attrs}) => m(ContentBrowser, {
			state: STATE,
			noUpload: false,
			filter: true,
			nofold: attrs.nofold,
			icon: "mountain",
			accept: "video/mp4",
			service: STATE.service,
			orga: attrs.orga,
			prefix: `${STATE.service}/${attrs.orga}/`,
			title: STR.YOUR_VIDEOS,
			loadContent: true,
			nopreview: true,
			emptyMessage: STR.YOUR_VIDEOS_EMPTY,
			emptyFilter: STR.YOUR_VIDEOS_EMPTY_FILTER,
			uploadMessage: STR.UPLOAD_VIDEO,
			itemWidget: ContentItem
		})
	),

	// widget: Main Screen
	ChromaKeyUploadScreen = defineWidget(
		({attrs}) => [
			m(TitleBarWidget, {
				title: "ChromaKey",
				rootTitle: "Studio",
				rootTitleClick: () => m.route.set(`/${attrs.orga}`)
			}),
			m(
				".flexcol.h-100.ohidden.grows.scrolly.outercontent",
				{
					class: STATE.mainBusy ? "mainbusy" : ""
				},
				m(".flexcol.grows.noshrink.innercontent", [

					// body
					...MAINSTATE.organization
						? [
							// show error if there is such
							...STATE.errorchroma
								? [
									m(NoticeWidget, {
										class: "rednotice marg-2 grows",
										icon: "exclamation-triangle",
										text: STATE.error,
										onClick: () => {
											delete STATE.errorchroma;
											m.redraw();
										}
									})
								]
								: [],

							m(".flexrow.ohidden.maincontainer.grows.chromascreen", [

								// If there is stuff in the bucker, or if there is a setlist playling


								m(".flexcol.grows.ohidden.part-left", [

									// Always show bucket list
									m(VideoContent, {orga: attrs.orga, state: STATE, nofold: true}),
								]),


								// right column
								m(".flexcol.grows.ohidden.part-right.h-100",
									[
										m(ChromaKeyPreviewWidget, {
											item: STATE.focusedItem,
											webroot: STATE.content.webroot
										})
									])
							])
						] : []
				])
			)
		],
		() => {
			document.title = STR.TITLE
		},
		undefined
	),

	ChromaKeyPreviewWidget = defineWidget(
		({attrs}) => m(CardieWidget, {
				class: "playlist",
				title: `Background ${attrs.item ? ` - ${attrs.item.key.split("/").pop()}` : ""}`,
				element: "div",
				bodyClass: "scrolly",
				cols: true,
				nofold: true,
			},
			[
				m(".tvscreen.flexcol.grows", attrs.item
					? [
						m("div.image",
							{
								class: "image169 relative ohidden chuck"
							},
							[
								...attrs.type === "png"
									? [
										m("img", {
											alt: "watermark " + attrs.item.key.split("/").pop(),
											src: ([STATE.content.webroot, attrs.item.key].join("/")) + "?_" + STATE.cacheKey
										})
									]
									: [
										m("video", {
											alt: "video " + attrs.item.key.split("/").pop(),
											src: ([attrs.webroot, attrs.item.key].join("/")),
											preload: "auto",
											muted: true,
											autoplay: "false",
											oncreate: ({dom}) => dom.scrollIntoView({
												behavior: "smooth",
												block: "center"
											})
										}),
									],
								m(".chuck")
							]
						)
					]
					: [
						m(Empty, {
							class: "darkie",
							icon: "image",
							message: STR.NO_ITEM
						})
					]),
				...attrs.item && !attrs.item.key.endsWith("/default.mp4")
					? [
						m(ButtonNew, {
							class: "unitheight colorbutton orange",
							icon: "stamp",
							text: STR.SET_BACKGROUND,
							onClick: () => confirm(STR.SET_BACKGROUND_CONFIRM, () => setAsDefault(attrs.item, "default.mp4"))
						})
					]
					: attrs.item
						? [
							m(NoticeWidget, {
								class: "notinorm",
								icon: "info-circle",
								text: STR.DEFAULT_BACKGROUND
							})
						]
						: []

			]
		)
	);

/**
 * Uploads the current image as the default watermark
 * @returns {Promise<void>}
 */

async function setAsDefault(item, defaultFilename = "default.mp4") {

	// basically upload current into default.png
	if (!item) return;

	const

		imageUrl = [STATE.content.webroot, item.key].join("/"),
		response = await fetch(imageUrl),
		blob = await response.blob(),

		// create a File object to re-use File Uploading service
		fakeFile = new File([blob], defaultFilename, {type: blob.type});

	await uploadFile(STATE, fakeFile, {refresh: () => m.redraw()});

	// update UI
	// affects default.png cache
	STATE.cacheKey = Date.now();

	m.redraw();
}

/////////////////////////ﬁ

export default ChromaKeyUploadScreen;
